import type { JSX } from 'react'
import type { FIXED_INDENTS } from 'vars/fixed-indents'
import type { INDENTS } from 'vars/indents'

import { Spinner } from 'atoms/Spinner'
import { TextBoxMaxLine1FontSmBold } from 'atoms/TextBox/Templates'
import { TextAligning } from 'atoms/TextBox/TextBox.h'
import { SearchLoaderSC } from './SearchLoader.styled'

interface ISearchLoaderProps {
  title?: string
  paddings?: INDENTS[] | FIXED_INDENTS[]
}

export const SearchLoader = ({
  title,
  paddings,
}: ISearchLoaderProps): JSX.Element => {
  return (
    <SearchLoaderSC paddings={paddings}>
      <Spinner />
      {title && (
        <TextBoxMaxLine1FontSmBold
          title={title}
          alignment={TextAligning.Center}
        />
      )}
    </SearchLoaderSC>
  )
}
